/* eslint-disable no-shadow */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { loadEmployerMetrics } from "../../actions/dashboardActions";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import employerPerformanceMetricsType from "./types/employerPerformanceMetricsType";
import {
  Wrapper,
  Header,
  MemberSince,
  Body,
  Row,
  Column,
  Number,
  Description,
  InfoDot,
} from "./styles/employer-performance-metrics-styles";
import { isFeatureEnabled } from "../../helpers";

export const EmployerPerformanceMetrics = ({
  loadEmployerMetrics,
  loading,
  employerMetrics,
  companyId,
}) => {
  useEffect(() => {
    loadEmployerMetrics({ companyId });
  }, []);

  const averageTimeToRespond = isFeatureEnabled("demoEnvironment")
    ? "1 day"
    : employerMetrics && employerMetrics.performance.averageTimeToRespond;

  const hhAverageTimeToRespond = isFeatureEnabled("demoEnvironment")
    ? "1 day"
    : employerMetrics && employerMetrics.performance.hhAverageTimeToRespond;

  return (
    <Wrapper data-test-id="employer-performance-metrics">
      {loading && <WidgetLoading />}
      <Header className="panel-heading">
        <div className="panel-title">Your Performance</div>
        <MemberSince>
          Member since{" "}
          {employerMetrics && employerMetrics.performance.memberSince}
        </MemberSince>
      </Header>
      <Body>
        <Row>
          <Column flex={1} data-test-id="avg-resp-time">
            <ReactTooltip
              html
              place="bottom"
              type="dark"
              effect="float"
              aria-haspopup="true"
              id="info-tooltip"
            />
            <Number
              fontSize="large"
              data-tip="The elapsed time between <br /> CV submitted and <br /> the first action <br /> taken on a candidate."
              data-for="info-tooltip"
            >
              {averageTimeToRespond}
              <InfoDot>
                <FontAwesomeIcon icon={faInfoCircle} />
              </InfoDot>
            </Number>
            <Description>Your Avg. Response Time</Description>
          </Column>
          <Column flex={1} data-test-id="hh-avg-resp-time">
            <ReactTooltip
              html
              place="bottom"
              type="dark"
              effect="float"
              aria-haspopup="true"
              id="info-tooltip-2"
            />
            <Number
              fontSize="large"
              data-tip="The average response <br /> time for employers <br /> using Hiring Hub."
              data-for="info-tooltip-2"
            >
              {hhAverageTimeToRespond}
              <InfoDot>
                <FontAwesomeIcon icon={faInfoCircle} />
              </InfoDot>
            </Number>
            <Description>HH Avg. Response Time</Description>
          </Column>
        </Row>
      </Body>
    </Wrapper>
  );
};

EmployerPerformanceMetrics.propTypes = {
  loadEmployerMetrics: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  employerMetrics: employerPerformanceMetricsType,
  companyId: PropTypes.number.isRequired,
};

EmployerPerformanceMetrics.defaultProps = {
  employerMetrics: PropTypes.shape({
    performance: PropTypes.shape({
      memberSince: PropTypes.isNull,
      avgResponseTime: PropTypes.isNull,
      hhAvgResponseTime: PropTypes.isNull,
    }),
  }),
};

const mapStateToProps = (state) => ({
  loading: state.dashboard.loading,
  employerMetrics: state.dashboard.employerMetrics,
});

export default connect(mapStateToProps, { loadEmployerMetrics })(
  EmployerPerformanceMetrics
);
